module.exports = __webpack_public_path__ + "img/work_from_office6.c60bd15e.png";